import {PageService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

export default {
	data() {
		return {
			loading: true,
			tabs: [],
			tabContent: []
		}
	},
	created() {
		this.getContent()

	},

	methods:{
	    getContent(){
	    	this.loading = true
	    	if(this.$breakpoints.xs || this.$breakpoints.sm) {
	    	  Vue.nextTick(() => {
	    	    if(this.$parent.$el != undefined) window.scroll({top: (this.$parent.$el.offsetTop - 100), left: 0, behavior: 'smooth'})
	    	  })
	    	}
	    	PageService.getGeneralPage("about_sk_b2b", null).then((response)=>{
  				this.tabContent = response[0].about_sk_b2b
  				Object.entries(this.tabContent).forEach((el, index)=>{
  					if (el[0] == this.$route.name) {
  						this.tabs.push(el[1])
  					}
  				})
  				this.loading = false
  			})
	    }
	},

	watch: {
		'$route' () {
			this.getContent()
		}
	},

	beforeUpdated() {
		this.getContent()
	}
}



// WEBPACK FOOTER //
// ./src/components/sales-at-sk/conferencing-and-venue-hire/conferencing-and-venue-hire.js